// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"cceceb16","90":"9f02cb0b","146":"9ffe5fae","634":"423839e1"}[chunkId] + ".chunk.js";
};